import { useEffect, useState } from "react";
import axios from "axios";

const API_URL = process.env.REACT_APP_API_URL;

/**
 * Fetches a server-signed timestamp when a public form mounts, to be submitted
 * alongside it. The server measures how long the form was open before it came
 * back: a submission faster than a human could type, or one replayed hours
 * later, is flagged.
 *
 * The signature is the point. A plain client-side "renderedAt" value is
 * forgeable in one line of script; an HMAC issued by the server is not.
 *
 * A failed fetch is not treated as an error. The form still submits — it just
 * arrives without timing evidence and the server flags it as such. Losing a
 * real message because a token request failed would be a worse outcome than
 * letting an unverified one through.
 */
export default function useFormToken() {
  const [formToken, setFormToken] = useState("");

  useEffect(() => {
    let cancelled = false;

    axios
      .get(`${API_URL}/api/form-token`)
      .then(({ data }) => {
        if (!cancelled && data?.token) setFormToken(data.token);
      })
      .catch(() => {
        /* submit without it; the server decides what that's worth */
      });

    return () => {
      cancelled = true;
    };
  }, []);

  return formToken;
}
